import React from "react";
import { Link } from "react-router-dom";
import { audiences } from "../../data/content.js";

// Big ruled rows with a hover shift, instead of three equal cards.
export default function Audiences() {
  return (
    <div className="pg-aud-list">
      {audiences.map((a, i) => (
        <Link className="pg-aud" to={`/${a.slug}`} key={a.slug}>
          <span className="pg-aud-n">0{i + 1}</span>
          <span className="pg-aud-t">{a.title}</span>
          <span className="pg-aud-d">{a.tagline}</span>
          <span className="pg-aud-a">{a.cta} →</span>
        </Link>
      ))}
    </div>
  );
}
